var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.47 2.928a.75.75 0 0 1 1.06 1.06L5.142 7.377h7.524l.077.003a.75.75 0 0 1 0 1.493l-.077.004H5.144L8.53 12.26l.05.058a.75.75 0 0 1-1.054 1.055l-.056-.052-4.667-4.666a.8.8 0 0 1-.12-.164q-.024-.039-.043-.08-.01-.032-.02-.065a.8.8 0 0 1-.037-.221c0-.081.016-.159.04-.232q.007-.026.015-.05l.004-.01a.8.8 0 0 1 .16-.239z"
  })));
};
export default Svg16;